import type { Catalog } from "./en.ts";

/** Korean copy. Same keys as en.ts; wording matches the editor before English-first. */
export const ko = {
  "doc.title": "Mapus",
  "brand.name": "매퍼스",
  "brand.tagline": "\uc9c0\ub3c4 \uc704\uc758 \ud018\uc2a4\ud2b8",
  "home.seo.intro":
    "지도에서 퀘스트를 둘러보고, 경로와 지역을 확인한 뒤 실제 거리에서 선을 따라가 보세요. 만든 사람은 루트 퀘스트를 공개하고, 플레이어는 이동 기록으로 경로를 따라 채워요.",

  "place.add": "점 찍기",
  "snapshot.save": "저장",
  "snapshot.open": "스냅샷",
  "snapshot.close": "닫기",
  "snapshot.saved": "도로 {count}개를 저장했습니다.",
  "snapshot.saved.one": "도로 {count}개를 저장했습니다.",
  "snapshot.none": "이 영역에 저장할 도로가 없습니다.",

  "account.logout": "로그아웃",
  "account.hello": "안녕하세요, {name}",
  "account.runner": "러너",
  "account.trust": "신뢰 {trust}",
  "account.signedOut": "로그아웃했습니다.",
  "account.logoutDiscard": "저장하지 않은 변경이 있습니다. 로그아웃하면 사라집니다. 계속할까요?",
  "account.signInFailed": "로그인에 실패했습니다.",

  "hint.tap": "오른쪽 클릭으로 점을 찍으세요. 휴대폰에서는 지도를 누르세요.",
  "hint.boundaryOpen": "영역을 따라 점을 찍고, 시작점을 누르거나 완료를 누르세요",
  "hint.boundaryClosed": "꼭짓점을 끌어 고치고, 길 채우기로 길을 넣으세요",
  "hint.erase": "선을 끌어서 지웁니다. Ctrl+스크롤로 브러시 크기를 바꿉니다.",
  "hint.workArea": "사각형을 드래그해 캔버스를 정합니다. 안의 도로는 한 번만 읽습니다.",
  "hint.zoomIn": "확대해서 그려 주세요",
  "hint.zoomRedraw": "확대해서 다시 그려 주세요",
  "hint.loading": "불러오는 중…",
  "hint.desktop":
    "오른쪽 클릭으로 점을 찍습니다. 점을 클릭하면 그 점을 고르고, 선을 클릭하면 그 선을 고릅니다. 선택된 점이나 선을 클릭하면 그것만 남고, 다시 클릭하면 선택이 풀립니다. 빈 곳을 클릭하면 선택이 풀립니다. Shift 클릭은 더하거나 뺍니다. W로 상자, 원, 올가미, 끄기를 바꿉니다. 상자, 원, 올가미는 점이나 선 위에서 시작해도 드래그해서 선택합니다. 점이나 선을 클릭하면 아무 일도 없고, 빈 곳을 클릭하면 선택이 풀립니다. Shift는 더하고 Ctrl은 빼며, 그 클릭은 선택을 풀지 않습니다. 끄기에서는 점과 선을 클릭하고 점을 끕니다. Ctrl+스크롤로 선택 원 크기를 바꿉니다. 점을 끌면 그 점을 옮깁니다. A를 반복하면 전체 선택, 장식선 제외 선택, 선택 해제를 순환합니다. 점이 숨겨지면 A, 상자, 원, 올가미, 클릭, 지우기는 점을 건너뛰고 선만 고릅니다. Alt+A로 선택을 풉니다. G로 선택한 점을 옮깁니다. J로 선택한 점을 잇고, M으로 한 점으로 합칩니다. 점이나 선이 선택되면 스타일에서 색, 크기, 두께, 모양을 바꿉니다. Ctrl+C로 선택한 점이나 선의 스타일을 복사하고, Ctrl+V로 붙입니다. 면은 닫힌 면을 모두 채우고, 채우기 없음은 면의 색을 모두 지웁니다. F로 영역 채우기를 열고, 다시 F를 누르면 나갑니다. Delete로 선이 두 개인 점은 이웃을 한 선으로 잇고 없애며, 끝점이나 갈림점은 붙은 선과 함께 지웁니다. X로 삭제 메뉴를 엽니다. 메뉴에서 D는 점을 녹여 지우고, K는 점과 선을 모두 지우고, L은 선만 지웁니다. E로 지우기를 켭니다. Ctrl+스크롤로 지우기 브러시 크기를 바꿉니다. H로 점을 보이거나 숨깁니다. Tab으로 양옆 창을 열고 닫습니다. 캔버스를 정하면 그 안의 길은 한 번만 읽습니다. 영역으로 길을 채우고, 지우기로 선을 지웁니다. Alt로 드래그하면 지도가 이동하고, Alt+Shift로 드래그하면 좌우로 돌리고 위아래로 기울입니다.",

  "badge.closed": "루프 완성",
  "title.label": "제목",
  "title.placeholder": "한강 야간 코스",

  "stats.points": "점",
  "stats.points.one": "점",
  "stats.distance": "거리",
  "stats.repeat": "반복",
  "stats.eta": "예상",
  "stats.disconnected": "끊김 · {count}곳",
  "stats.disconnectedNext": "다음 끊긴 부분으로 이동",
  "issues.gaps": "틈 {count}곳",
  "issues.gaps.one": "틈 {count}곳",
  "issues.overlaps": "겹침 {count}곳",
  "issues.overlaps.one": "겹침 {count}곳",
  "issues.crossings": "교차 {count}곳",
  "issues.crossings.one": "교차 {count}곳",
  "issues.next": "다음 위치로 이동",
  "edit.selectSmallerParts": "작은 부분 선택",

  "nearby.open": "근처",
  "nearby.close": "근처 닫기",
  "nearby.title": "\uadfc\ucc98 \ud018\uc2a4\ud2b8",
  "nearby.empty": "\uc774 \uadfc\ucc98\uc5d4 \uc544\uc9c1 \ud018\uc2a4\ud2b8\uac00 \uc5c6\uc5b4\uc694. \uc9c0\ub3c4\ub97c \uc62e\uaca8 \ub458\ub7ec\ubcf4\uc138\uc694.",
  "nearby.failed": "\uadfc\ucc98 \ud018\uc2a4\ud2b8\ub97c \ubd88\ub7ec\uc624\uc9c0 \ubabb\ud588\uc5b4\uc694.",
  "nearby.meta": "{away} \uac70\ub9ac \u00b7 {length} \u00b7 \uc57d {time}",
  "nearby.metaRoute": "{length} \u00b7 \uc57d {time}",
  "nearby.metaSpots": "{away} \u00b7 {count} \u00b7 \uc57d {time}",
  "nearby.metaSpotsRoute": "{count} \u00b7 \uc57d {time}",
  "nearby.anonymous": "익명",
  "nearby.busy": "\ud3b8\uc9d1 \uc911\uc5d0\ub294 \uadfc\ucc98 \ud018\uc2a4\ud2b8\ub97c \uc5f4\uc9c0 \uc54a\uc544\uc694.",
  "nearby.emptyCreate": "\uc5ec\uae30 \uc88b\uc740 \uae38\uc744 \uc54c\uace0 \uc788\ub098\uc694? \uccab \ud018\uc2a4\ud2b8\ub97c \ub9cc\ub4e4\uc5b4 \ubcf4\uc138\uc694.",
  "nearby.searchArea": "\uc774 \uc9c0\uc5ed \ud018\uc2a4\ud2b8 \ubcf4\uae30",
  "quests.mine": "\ub0b4 \ud018\uc2a4\ud2b8",
  "quests.interest": "\uad00\uc2ec \ud018\uc2a4\ud2b8",
  "quests.interestEmpty": "\uc544\uc9c1 \uc800\uc7a5\ud55c \ud018\uc2a4\ud2b8\uac00 \uc5c6\uc5b4\uc694. \ud018\uc2a4\ud2b8 \ud398\uc774\uc9c0\uc758 \ud558\ud2b8\ub97c \ub20c\ub7ec \uc800\uc7a5\ud558\uc138\uc694.",
  "quests.interestSignIn": "\uc800\uc7a5\ud55c \ud018\uc2a4\ud2b8\ub97c \ubcf4\ub824\uba74 \ub85c\uadf8\uc778\ud558\uc138\uc694.",
  "quests.interestFailed": "\uc800\uc7a5\ud55c \ud018\uc2a4\ud2b8\ub97c \ubd88\ub7ec\uc624\uc9c0 \ubabb\ud588\uc5b4\uc694.",
  "quests.signInToSave": "\ud018\uc2a4\ud2b8\ub97c \uc800\uc7a5\ud558\ub824\uba74 \ub85c\uadf8\uc778\ud558\uc138\uc694.",
  "quest.saveQuest": "\ud018\uc2a4\ud2b8 \uc800\uc7a5",
  "quest.unsaveQuest": "\uc800\uc7a5 \ucde8\uc18c",
  "home.estTime": "\uc608\uc0c1 \uc2dc\uac04",
  "home.notFound": "\uc774 \ud018\uc2a4\ud2b8\ub294 \ubcfc \uc218 \uc5c6\uc5b4\uc694.",
  "home.deleted": "\ud018\uc2a4\ud2b8\ub97c \uc0ad\uc81c\ud588\uc5b4\uc694.",
  "home.openQuestPage": "퀘스트 페이지 열기: {title}",
  "home.questZoom": "이 퀘스트로 줌",
  "home.closeDetail": "닫기",
  "home.viewDetails": "자세히 보기",

  "sheet.history": "기록",
  "sheet.tools": "도구",
  "sheet.edit": "편집",
  "sheet.style": "스타일",
  "sheet.view": "보기",
  "sheet.workArea": "캔버스",
  "sheet.save": "저장",

  "toolbar.undo": "되돌리기",
  "toolbar.redo": "다시하기",
  "toolbar.snap": "자석",
  "toolbar.crosshair": "조준점",
  "toolbar.hidePoints": "점 숨기기",
  "toolbar.showPoints": "점 보이기",
  "toolbar.deselect": "선택 해제",
  "toolbar.selectBox": "상자",
  "toolbar.selectCircle": "원",
  "toolbar.selectLasso": "올가미",
  "toolbar.selectOff": "끄기",
  "toolbar.more": "패널 펼치기·접기",
  "toolbar.details": "상세 펼치기·접기",
  "toolbar.area": "영역",
  "toolbar.done": "완료",
  "toolbar.clearArea": "영역 지우기",
  "toolbar.fillRoads": "길 채우기",
  "toolbar.runFillRoads": "채우기",
  "toolbar.fillColor": "색 채우기",
  "toolbar.erase": "지우기",
  "toolbar.workArea": "캔버스",
  "toolbar.clearWorkArea": "캔버스 지우기",

  "eraseSize.label": "크기 조절",
  "spacing.label": "간격",
  "spacing.meters": "{meters}m",

  "action.save": "저장",
  "action.saving": "저장 중…",

  "legend.on": "도로",
  "legend.near": "근처",
  "legend.off": "벗어남",

  "menu.deletePoint": "점 삭제",
  "menu.start": "시작점",
  "menu.importGpx": "GPX 가져오기",
  "menu.clearAll": "전체 지우기",
  "menu.settings": "설정",
  "menu.open": "메뉴",
  "menu.clearCache": "캐시 지우기",

  "settings.title": "설정",
  "settings.back": "뒤로",
  "settings.close": "닫기",

  "style.title": "스타일",
  "style.faces": "면",
  "style.apply": "적용",
  "style.pointColor": "점 색",
  "style.pointSize": "점 크기",
  "style.lineColor": "선 색",
  "style.lineWidth": "선 두께",
  "style.pattern": "선 모양",
  "style.solid": "실선",
  "style.dashed": "파선",
  "style.dotted": "점선",
  "style.decorative": "장식선",
  "style.decorativeMixed": "장식선 섞임",
  "style.mixed": "섞임",
  "style.px": "px",
  "style.defaults": "스타일 기본값",
  "style.defaultsHint": "새로 찍는 점과 선에 쓰입니다.",
  "style.customColor": "직접 고른 색",

  "graphics.title": "그래픽 가속",
  "theme.title": "창 테마",
  "theme.white": "흰색",
  "theme.dark": "어두운 창",
  "theme.glass": "반투명 유리",
  "account.label": "계정",
  "graphics.statusLabel": "상태",
  "graphics.on": "켜짐",
  "graphics.off": "꺼짐",
  "graphics.unknown": "알 수 없음",
  "graphics.rendererLabel": "렌더러",
  "graphics.rendererUnknown": "확인 불가",
  "graphics.toast": "그래픽 가속이 꺼져 있어 지도가 느리게 그려질 수 있습니다.",
  "graphics.toastOpen": "설정",
  "graphics.toastDismiss": "닫기",
  "graphics.chromeTitle": "Chrome",
  "graphics.chrome1": "chrome://settings/system 을 엽니다.",
  "graphics.chrome2": "‘가능한 경우 그래픽 가속 사용’을 켭니다.",
  "graphics.chrome3": "Chrome을 다시 시작합니다.",
  "graphics.chrome4": "chrome://gpu 에서 하드웨어 가속이 켜져 있는지 확인합니다.",
  "graphics.edge": "Edge: edge://settings/system 에서 ‘사용 가능한 경우 그래픽 가속 사용’을 켜고 다시 시작합니다. edge://gpu 에서 확인합니다.",
  "graphics.safari": "Safari는 Mac의 GPU를 따릅니다. macOS를 업데이트하고, 지도가 계속 느리면 저전력 모드를 끕니다.",
  "graphics.firefox": "Firefox: 설정, 일반, 성능에서 ‘사용 가능한 경우 하드웨어 가속 사용’을 켠 뒤 다시 시작합니다.",

  "keymap.title": "키맵",
  "keymap.preset": "프리셋: {name}",
  "keymap.preset.default": "기본",
  "keymap.reset": "기본값으로",
  "keymap.capture": "키, 스크롤, 또는 드래그하세요",
  "keymap.conflict": "{action}에서 이미 쓰고 있습니다.",
  "keymap.mod.alt": "Alt",
  "keymap.mod.shift": "Shift",
  "keymap.mod.ctrl": "Ctrl",
  "keymap.mod.meta": "Cmd",
  "keymap.drag": "드래그",
  "keymap.click": "클릭",
  "keymap.wheel": "스크롤",
  "keymap.button.middle": "가운데",
  "keymap.button.right": "오른쪽",
  "keymap.panView": "화면 이동",
  "keymap.rotateView": "화면 회전",
  "keymap.placeAtCenter": "점 찍기",
  "keymap.selectAll": "전체 선택 순환",
  "keymap.deselectAll": "모두 선택 해제",
  "keymap.cycleSelectTool": "선택 도구 바꾸기",
  "keymap.deleteUnderCursor": "커서 아래 점 삭제",
  "keymap.lassoSelect": "올가미 선택",
  "keymap.lassoAdd": "올가미 추가",
  "keymap.lassoSubtract": "올가미 빼기",
  "keymap.drawWorkArea": "캔버스 그리기",
  "keymap.moveSelected": "선택 이동",
  "keymap.join": "잇기",
  "keymap.merge": "합치기",
  "keymap.copyStyle": "스타일 복사",
  "keymap.pasteStyle": "스타일 붙여넣기",
  "keymap.toggleDecorative": "장식선",
  "keymap.savePiece": "저장",
  "keymap.exitEdit": "편집 나가기",
  "keymap.enterEdit": "편집 들어가기",
  "keymap.fillTool": "영역 채우기",
  "keymap.clearRegion": "채우기 지우기",
  "keymap.exitFill": "영역 채우기 나가기",
  "keymap.deleteSelected": "선택 삭제",
  "keymap.deleteMenu": "삭제 메뉴",
  "keymap.erase": "지우기",
  "keymap.showPoints": "점 보이기",
  "keymap.toggleSnap": "스냅 켜기/끄기",
  "keymap.fillRoadsTool": "길 채우기",
  "keymap.cycleRoadsTool": "길 채우기 도구 바꾸기",
  "keymap.roadsClear": "길 채우기: 영역 지우기",
  "keymap.roadsFill": "길 채우기: 채우기",
  "keymap.roadsBoxFill": "길 채우기: 상자",
  "keymap.roadsCircleStroke": "길 채우기: 원 긋기",
  "keymap.resizeRoadsBrush": "길 채우기 브러시 크기",
  "keymap.workArea": "캔버스",
  "keymap.clearWorkArea": "캔버스 지우기",
  "keymap.moveCanvas": "캔버스 이동",
  "keymap.resizeCanvas": "캔버스 크기 조절",
  "keymap.rotateCanvas": "캔버스 회전",
  "workPrompt.title": "먼저 캔버스를 잡아줘",
  "workPrompt.body": "지도에서 드래그해서 사각형으로 캔버스 영역을 지정하면 돼.",
  "workPrompt.start": "캔버스 잡기",
  "workPrompt.later": "나중에",
  "keymap.select": "선택",
  "keymap.toggleSelect": "선택 토글",
  "keymap.zoomMap": "지도 확대·축소",
  "keymap.resizeEraseBrush": "지우기 브러시 크기",
  "keymap.resizeSelectCircle": "선택 원 크기",
  "keymap.zoomIn": "확대",
  "keymap.zoomOut": "축소",
  "keymap.zoomInMore": "더 확대",
  "keymap.zoomOutMore": "더 축소",
  "keymap.panLeft": "왼쪽으로 이동",
  "keymap.panRight": "오른쪽으로 이동",
  "keymap.panUp": "위로 이동",
  "keymap.panDown": "아래로 이동",
  "keymap.northUp": "북쪽",
  "keymap.toggleDrawers": "양옆 창 열기/닫기",
  "keymap.toggleBasemap": "위성 지도 토글",
  "keymap.toggleStreetView": "거리뷰",
  "keymap.movePoint": "점 끌기",
  "keymap.eraseStroke": "지우기 긋기",
  "keymap.moveBoundary": "영역 꼭짓점 끌기",
  "keymap.confirmGrab": "이동 확정",
  "keymap.cancelGrab": "이동 취소",
  "keymap.confirmDeleteMenu": "삭제 확정",
  "keymap.cancelDeleteMenu": "삭제 취소",
  "keymap.deleteMenuNext": "다음 삭제 항목",
  "keymap.deleteMenuPrev": "이전 삭제 항목",
  "keymap.deleteMenuPoints": "점 삭제",
  "keymap.deleteMenuLines": "선만 삭제",
  "keymap.deleteMenuPointsAndLines": "점과 선 모두 삭제",


  "hint.joinFew": "이으려면 점을 두 개 이상 선택하세요.",
  "hint.mergeFew": "합치려면 점을 두 개 이상 선택하세요.",
  "hint.fillRegion": "닫힌 영역 안을 클릭하면 색이 채워집니다. 채우기 없음은 그 영역의 색을 지웁니다. Alt+클릭으로도 채우기를 지웁니다. 색 칩을 누르면 색을 바꿉니다. F나 Esc로 나갑니다.",
  "hint.fillRegionNone": "그곳에는 닫힌 영역이 없습니다.",
  "hint.selected": "{count}개 선택",
  "hint.selectBox": "상자 선택 — 드래그해서 선택. 빈 곳을 클릭하면 선택이 풀립니다.",
  "hint.selectCircle": "원 선택 — 드래그하는 동안 칠합니다. 빈 곳을 클릭하면 선택이 풀립니다.",
  "hint.selectLasso": "올가미 선택 — 드래그해서 선택. 빈 곳을 클릭하면 선택이 풀립니다.",
  "hint.selectOff": "끄기 — 클릭해서 선택",
  "hint.roadsBox": "상자 채우기 — 사각형을 드래그하고 놓으면 안의 길을 채웁니다.",
  "hint.roadsCircle": "원 채우기 — 드래그해서 길을 칠합니다. Ctrl+스크롤로 브러시 크기를 바꿉니다.",

  "move.hint": "점 {count}개 이동: 클릭이나 Enter로 확정, Esc나 오른쪽 클릭으로 취소",
  "move.hint.one": "점 {count}개 이동: 클릭이나 Enter로 확정, Esc나 오른쪽 클릭으로 취소",

  "delete.points": "점 삭제",
  "delete.lines": "선만 삭제",
  "delete.pointsAndLines": "점과 선 모두 삭제",
  "delete.none": "지울 점이나 선을 먼저 고르세요.",

  "trust.label": "신뢰도",
  "saved.new": "새 그림",
  "saved.trust": "신뢰 {trust}",
  "saved.loop": "루프 · ",

  "confirm.clear": "그린 선을 모두 지울까요?",
  "confirm.saveEdit": "저장하지 않은 변경이 있어요.",
  "confirm.save": "저장하고 나가기",
  "confirm.discard": "버리고 나가기",
  "confirm.cancel": "취소",
  "confirm.signIn": "저장하려면 Google로 로그인해 주세요.",
  "confirm.publish": "한 번 공개하면 다시는 편집할 수 없어요. 모두에게 공개할까요?",
  "confirm.publishOk": "공개",
  "mode.edit": "편집",
  "mode.exit": "나가기",
  "mode.view": "← 보기",
  "mode.publish": "공개",
  "status.private": "비공개",
  "status.public": "공개",
  "leave.upload": "올리고 나가기",
  "leave.draft": "임시 저장하고 나가기",
  "leave.discard": "버리고 나가기",
  "style.summary": "점 · 선 · 면",
  "pieces.title": "내 그림",
  "pieces.empty": "그림이 없습니다.",
  "pieces.signedOut": "로그인하면 저장한 그림이 보입니다.",
  "pieces.local": "아직 올리지 않음",
  "pieces.published": "공개됨",
  "pieces.new": "새 그림",
  "pieces.delete": "삭제",
  "pieces.deleteConfirm": "이 그림을 삭제할까요?",
  "pieces.deletePublic": "삭제",
  "cache.clear": "캐시 지우기",
  "cache.cleared": "캐시를 지웠어요.",
  "pieces.deletePublicConfirm": "이 공개 그림을 모두에게서 삭제할까요? 되돌릴 수 없어요.",
  "pieces.deletedPublic": "공개 그림을 삭제했어요.",
  "toast.draft": "저장된 초안을 불러왔습니다.",
  "toast.draftLeft": "임시 저장하고 편집을 나갔어요.",
  "toast.newPiece": "새 그림을 시작하세요.",
  "toast.needTitle": "제목을 입력해 주세요.",
  "toast.needLogin": "저장하려면 Google로 로그인해 주세요.",
  "toast.saved": "저장했습니다.",
  "toast.loadFailed": "불러오기에 실패했습니다.",
  "toast.saveFailed": "저장에 실패했습니다.",
  "toast.published": "공개했습니다.",
  "toast.publishFailed": "공개에 실패했습니다.",
  "toast.locked": "\uacf5\uac1c\ub41c \ud018\uc2a4\ud2b8\ub294 \ud3b8\uc9d1\ud560 \uc218 \uc5c6\uc5b4\uc694.",
  "toast.gpxRoute": "GPX 루트를 가져왔습니다.",
  "toast.gpxTrack": "GPX 트랙을 가져왔습니다.",
  "toast.loaded": "불러옴: {title}",
  "toast.canvasCleared": "캔버스를 지웠어요 — {undo}로 되돌리기",
  "toast.selectAll.all": "전체 선택",
  "toast.selectAll.excludeDecorative": "장식선 제외 선택",
  "toast.selectAll.clear": "선택 해제",
  "toast.north": "북쪽",
  "toast.northBack": "이전 시점으로 돌아왔어요",
  "toast.northRoute": "경로 방향으로 돌렸어요",
  "toast.basemapUnavailable": "위성 지도를 지금은 쓸 수 없어요.",
  "toast.geolocationDenied": "위치 권한이 없어요. 브라우저 설정에서 허용해 주세요.",
  "toast.geolocationUnavailable": "지금은 위치를 가져올 수 없어요.",

  "gpx.empty": "GPX에서 트랙이나 루트를 찾지 못했습니다.",
  "gpx.failed": "GPX를 읽지 못했습니다.",

  "route.disconnected": "끊긴 구간이 있어 저장할 수 없습니다.",
  "route.empty": "구간을 하나 이상 이어 주세요.",

  "fill.closeFirst": "영역을 먼저 닫아 주세요.",
  "fill.tooLarge": "영역이 너무 넓습니다. 더 작게 그려 주세요.",
  "fill.fit": "영역이 화면에 다 보이게 맞춘 뒤 채워 주세요.",
  "fill.zoom": "이 배율에서는 도로가 보이지 않습니다. 확대해서 다시 채워 주세요.",
  "fill.tooMany": "점이 너무 많습니다. 간격을 넓히거나 영역을 줄여 주세요.",
  "fill.empty": "이 영역 안에서 길을 찾지 못했습니다.",
  "fill.done": "길을 채웠습니다.",

  "fillRegion.none": "채우기 없음",
  "fillRegion.changeColor": "채우기 색 바꾸기",
  "fillRegion.custom": "사용자 색",
  "fillRegion.customEmpty": "빈 사용자 색",
  "fillRegion.customSlot": "사용자 색 {n}",
  "fillRegion.palette.default": "기본",
  "fillRegion.palette.pastel": "파스텔",
  "fillRegion.palette.vivid": "선명",
  "fillRegion.palette.earth": "대지",
  "fillRegion.palette.mono": "모노",

  "workArea.outside": "그 지점은 캔버스 밖입니다.",
  "snap.on": "자석 켜짐",
  "decorativeStroke.on": "새 선은 장식선",
  "decorativeStroke.off": "새 선 장식선 해제",
  "snap.off": "자석 꺼짐",
  "snap.noPaths": "캔버스 안에서 길을 찾지 못했습니다",
  "workArea.need": "먼저 캔버스를 정하세요.",

  "eta.minutes": "{count}분",
  "eta.minutes.one": "{count}분",
  "eta.hours": "{count}시간",
  "eta.hours.one": "{count}시간",
  "eta.hoursMinutes": "{hours}시간 {minutes}분",


  "quests.title": "퀘스트",
  "quests.create": "새 퀘스트",
  "quests.empty": "퀘스트가 아직 없습니다.",
  "quests.draft": "초안",
  "quests.published": "게시됨",
  "quests.untitled": "제목 없음",
  "quests.noRoute": "아직 경로가 없어요. 편집에서 추가할 수 있어요.",
  "quests.loadFailed": "퀘스트를 불러오지 못했습니다.",
  "quests.signInToCreate": "퀘스트를 만들려면 로그인하세요.",

  "quest.backHome": "지도로 돌아가기",
  "quest.signInRequired": "퀘스트를 만들려면 로그인하세요.",
  "quest.status.draft": "초안",
  "quest.status.published": "게시됨",
  "quest.saveDraft": "초안 저장",
  "quest.preview": "미리보기",
  "quest.publish": "게시",
  "quest.edit": "편집",
  "quest.deleteDraft": "초안 삭제",
  "quest.delete": "삭제",
  "quest.cover.placeholder": "커버 이미지",
  "quest.cover.url": "커버 이미지 URL 붙여넣기",
  "quest.title.placeholder": "퀘스트 제목",
  "quest.tagline.placeholder": "짧은 소개",
  "quest.city": "도시",
  "quest.country": "국가",
  "quest.tags.placeholder": "태그 입력 후 Enter",
  "quest.by": "{name}",
  "quest.byUnknown": "익명",
  "quest.summary.distance": "거리",
  "quest.summary.time": "시간",
  "quest.summary.spots": "스팟",
  "quest.line.none": "라인 없음",
  "quest.line.pickMine": "내 그림",
  "quest.line.pickNearby": "근처 루트",
  "quest.line.pickPrompt": "번호로 라인을 고르세요:",
  "quest.line.noneMine": "라인으로 쓰려면 먼저 퀘스트 루트를 공개하세요.",
  "quest.line.noneNearby": "근처에 공개 루트가 없습니다.",
  "quest.map.hint": "지도를 클릭해 스팟을 추가하고, 마커를 끌어 옮기세요.",
  "quest.spots": "스팟",
  "quest.spots.empty": "스팟이 없습니다.",
  "quest.spots.emptyEdit": "지도를 클릭해 시작·종료 스팟을 추가하세요.",
  "quest.spot.untitled": "제목 없는 스팟",
  "quest.spot.title": "제목",
  "quest.spot.minutes": "분",
  "quest.spot.radius": "반경 (m)",
  "quest.spot.photoRequired": "사진 필수",
  "quest.spot.remove": "스팟 삭제",
  "quest.spot.start": "시작",
  "quest.spot.finish": "종료",
  "quest.min": "분",
  "quest.slot.stamp": "스탬프",
  "quest.slot.photo": "사진",
  "quest.unlock.title": "도착 시 공개",
  "quest.unlock.story": "숨은 이야기",
  "quest.unlock.pose": "포즈 힌트",
  "quest.unlock.link": "링크 (YouTube / X / Instagram)",
  "quest.story": "스토리",
  "quest.manners": "매너",
  "quest.text.placeholder": "여기에 작성…",
  "quest.text.empty": "—",
  "quest.more.title": "더보기",
  "quest.more.placeholder": "더 많은 콘텐츠는 곧 제공됩니다",
  "quest.saved": "초안을 저장했습니다.",
  "quest.saveFailed": "퀘스트를 저장하지 못했습니다.",
  "quest.publishConfirm": "게시한 퀘스트는 수정할 수 없고 삭제만 가능하며 항상 공개됩니다. 게시할까요?",
  "quest.published": "퀘스트를 게시했습니다.",
  "quest.publishFailed": "퀘스트를 게시하지 못했습니다.",
  "quest.deleteConfirm": "이 퀘스트를 삭제할까요? 되돌릴 수 없습니다.",
  "quest.deleteFailed": "퀘스트를 삭제하지 못했습니다.",

  "quests.new": "새 퀘스트",
  "qpick.kicker": "새 퀘스트",
  "qpick.title": "어떤 퀘스트를 만들까요?",
  "qpick.sub": "하나를 고르면 한 단계씩 안내해 드려요.",
  "qpick.spot.title": "장소 퀘스트",
  "qpick.spot.line": "순서 없이 스팟 방문",
  "qpick.spot.detail":
    "각 스팟마다 제목, 설명, 썸네일, 지도 위치가 필요해요. 원하는 만큼 추가하세요.",
  "qpick.route.title": "GPS 아트 퀘스트",
  "qpick.route.line": "지도에 그린 경로를 따라 걷기",
  "qpick.route.detail": "제목과 그린 경로가 필요해요. 출발과 도착은 자동으로 추가돼요.",
  "qpick.start": "시작 →",
  "qpick.soon": "준비 중",
  "qpick.creating": "퀘스트를 준비하는 중…",
  "qbar.newQuest": "새 퀘스트",
  "qbar.draftQuest": "초안 퀘스트",
  "qbar.draft": "초안",
  "qbar.published": "공개됨",
  "qbar.savedJustNow": "방금 초안 저장됨",
  "qbar.savedAgo": "초안 저장됨 · {count}분 전",
  "qbar.saving": "저장 중…",
  "qbar.saveFailed": "초안을 저장하지 못했어요",
  "qbar.save": "저장",
  "qbar.autosave": "자동 저장",
  "qbar.saveChanges": "변경사항 저장",
  "qbar.unsaved": "저장 안 됨",
  "qbar.unsavedLive": "저장 안 됨",
  "qbar.liveSaving": "저장 중…",
  "qbar.liveSavedJustNow": "저장됨",
  "qbar.liveSavedAgo": "저장됨 · {count}분 전",
  "qbar.liveSaveFailed": "저장하지 못했어요 · 저장을 다시 눌러 주세요",
  "qbar.unsavedLeaveConfirm": "저장하지 않은 변경이 있어요. 저장하지 않고 나갈까요?",
  "qbar.preview": "플레이어로 미리보기",
  "qbar.exit": "나가기",
  "qpage.label": "라이브 페이지 — 플레이어가 보는 그대로",
  "rt.kicker": "GPS 아트 퀘스트 · 지도의 경로 따라 걷기",
  "rt.spot.kicker": "장소 퀘스트 · 순서 없이 둘러볼 장소",
  "rt.spot.sub": "제목, 설명, 사진, 위치를 넣은 스팟을 추가한 뒤 발행하세요.",
  "rt.spot.heading": "스팟을 추가해 볼까요",
  "rt.spots": "스팟",
  "rt.spots.desc": "각 스팟마다 제목, 설명, 썸네일, 위치가 필요해요.",
  "rt.spots.kicker": "스팟",
  "rt.spots.q": "어디로 가면 될까요?",
  "rt.spots.tapHint": "지도를 탭하거나 주소를 검색하고, 마커를 드래그해 위치를 맞추세요.",
  "rt.spots.tapToast": "지도를 탭해 스팟을 추가하세요.",
  "rt.spots.addMap": "+ 지도에 추가",
  "rt.spots.add": "+ 스팟 추가",
  "rt.spots.titlePh": "스팟 제목",
  "rt.spots.descPh": "이 스팟에 대해 알려 주고 싶은 내용",
  "rt.spots.thumb": "썸네일",
  "rt.spots.thumbUpload": "사진 업로드",
  "rt.spots.thumbReplace": "사진 바꾸기",
  "rt.spots.location": "위치",
  "rt.spots.typeLabel": "스팟",
  "rt.spots.images": "이미지",
  "rt.spots.imagesAdd": "이미지 추가",
  "rt.spots.imagesRemove": "삭제",
  "rt.spots.imagesMoveUp": "위로",
  "rt.spots.imagesMoveDown": "아래로",
  "rt.spots.imageCaptionPh": "사진 설명",
  "rt.spots.thumbCrop.title": "썸네일 자르기",
  "rt.spots.thumbCrop.hint": "끌어서 위치를 맞추세요. 지도 마커용 {size}×{size} 정사각형으로 저장돼요.",
  "rt.spots.locationEdit": "위치 고르기",
  "rt.spot.location.search": "장소나 주소 검색",
  "rt.spot.location.set": "여기로 정하기",
  "rt.spot.location.coords": "{lat}, {lng}",
  "rt.spot.location.preview": "{address} · {lat}, {lng}",
  "rt.spot.location.noResults": "검색 결과가 없어요. 다른 단어를 쓰거나 지도를 탭해 보세요.",
  "rt.spot.location.searching": "검색 중…",
  "rt.spot.location.searchFailed": "지금은 장소 검색을 쓸 수 없어요.",
  "rt.spot.lightbox.title": "스팟 사진",
  "rt.spot.lightbox.close": "닫기",
  "rt.spot.lightbox.prev": "이전 사진",
  "rt.spot.lightbox.next": "다음 사진",
  "rt.spot.mapPickHint": "지도에서 스팟을 눌러 보세요.",
  "rt.spot.mapClose": "스팟 카드 닫기",
  "rt.spot.mapPickList": "이 지도의 스팟",
  "rt.spots.delete": "삭제",
  "rt.spots.deleteConfirm": "「{title}」 지울까요?",
  "rt.heading": "경로를 그려 볼까요",
  "rt.headingReady": "좋아요. 더 넣고 싶은 게 있나요?",
  "rt.sub": "한 단계씩 진행해요. 경로, 경로 설정, 제목만 있으면 돼요.",
  "rt.subReady": "바꾼 내용은 바로 페이지에 보여요. 원할 때 더 추가하세요.",
  "rt.required": "필수",
  "rt.editor.selectHint": "목록이나 미리보기에서 항목을 선택하면 여기서 편집할 수 있어요.",
  "rt.editor.palette": "블록 추가",
  "rt.editor.palettePhoto": "표지 사진",
  "rt.editor.palettePhotoBlock": "사진",
  "rt.editor.paletteSpot": "스팟",
  "rt.editor.paletteText": "텍스트",
  "rt.editor.drag": "끌어서 순서 변경",
  "rt.editor.moveUp": "위로",
  "rt.editor.moveDown": "아래로",
  "rt.spots.locationEmpty": "위치 미설정",
  "rt.optionalDivider": "원하면 더 추가하기",
  "rt.soon": "준비 중",
  "rt.route": "경로",
  "rt.route.desc": "사람들이 걸을 길을 그려요.",
  "rt.route.add": "+ 경로 추가",
  "rt.route.mapAdded": "지도를 넣었어요 — 지도의 편집을 누르세요. 에디터가 새 창으로 열려요.",
  "rt.route.summary": "경로 · {distance} · 에디터에서 저장됨",
  "rt.settings": "경로 설정",
  "rt.settings.desc": "출발과 도착, 제한 시간.",
  "rt.settings.needRoute": "먼저 경로를 추가한 뒤 플레이 방식을 골라요.",
  "rt.title": "제목과 커버",
  "rt.title.desc": "걷고 싶어지는 이름을 지어 주세요.",
  "rt.description": "설명",
  "rt.description.desc": "이 퀘스트가 어떤 건지 알려 주세요.",
  "rt.mission": "미션",
  "rt.mission.desc": "가는 길에 할 일을 추가해요.",
  "rt.secrets": "스팟 비밀",
  "rt.secrets.desc": "스팟에 비밀을 숨겨요.",
  "rt.story": "소개 이야기",
  "rt.story.desc": "여기엔 어떤 이야기가 있나요?",
  "rt.manners": "매너",
  "rt.manners.desc": "나누고 싶은 길 위의 매너가 있나요?",
  "rt.decorate": "꾸미기",
  "rt.decorate.desc": "페이지 어디에나 재미있는 걸 붙여요.",
  "rt.publish": "퀘스트 공개",
  "rt.adminPublished.banner": "게시된 퀘스트예요. 저장하면 바로 반영돼요.",
  "rt.adminPublished.collapsedLabel": "퀘스트 편집",
  "rt.publishNote": "전 세계 플레이어를 위해 자동 번역돼요.",
  "rt.publish.blockedTitle": "공개하려면",
  "rt.publish.needTitle": "퀘스트 제목을 입력하세요",
  "rt.publish.needRoute": "경로를 그려 주세요",
  "rt.publish.needSettings": "경로 설정을 마치세요",
  "rt.publish.needSpots": "스팟을 하나 이상 추가하세요",
  "rt.publish.needSpotFields": "모든 스팟의 제목, 설명, 사진, 위치를 채우세요",
  "rt.published.heading": "퀘스트가 공개됐어요",
  "rt.published.sub": "공개된 퀘스트는 수정할 수 없어요. 삭제는 할 수 있어요.",
  "rt.published.view": "퀘스트 페이지 열기",
  "rt.page.spots": "스팟",
  "rt.page.start": "출발",
  "rt.page.finish": "도착",
  "rt.page.area": "퀘스트 지도",
  "rt.page.placeRegion": "지역",
  "rt.page.story": "이야기",
  "rt.page.manners": "매너",
  "rt.page.photo": "사진",
  "rt.page.photoCaption": "캡션 (선택)",
  "rt.page.photoCaptionPh": "짧은 설명을 적어 주세요",
  "rt.block.limit": "맞춤 블록은 최대 48개까지 추가할 수 있어요.",
  "rt.block.missing": "블록을 찾을 수 없어요.",
  "rt.block.tip.palette": "팁",
  "rt.block.tip.title": "팁",
  "rt.block.tip.label": "팁 내용",
  "rt.block.tip.placeholder": "준비물, 방문하기 좋은 시간, 주차 등",
  "rt.block.quote.palette": "인용",
  "rt.block.quote.title": "인용",
  "rt.block.quote.label": "인용문",
  "rt.block.quote.attribution": "출처 (선택)",
  "rt.block.quote.attributionPh": "말한 사람",
  "rt.block.link.palette": "링크",
  "rt.block.link.title": "링크",
  "rt.block.link.url": "URL",
  "rt.block.link.titleField": "제목 (선택)",
  "rt.block.link.titlePh": "링크 제목",
  "rt.block.divider.palette": "구분선",
  "rt.block.divider.title": "구분선",
  "rt.block.divider.note": "페이지에 가로 줄이 표시돼요. 편집할 항목은 없어요.",
  "rt.block.quiz.palette": "퀴즈",
  "rt.block.quiz.title": "질문/퀴즈",
  "rt.block.quiz.question": "질문",
  "rt.block.quiz.answer": "정답",
  "rt.block.quiz.hint": "힌트 (선택)",
  "rt.block.quiz.reveal": "정답 보기",
  "rt.block.gallery.palette": "갤러리",
  "rt.block.gallery.title": "갤러리",
  "rt.block.gallery.add": "사진 추가",
  "rt.block.gallery.remove": "사진 삭제",
  "rt.block.gallery.count": "사진 {count}장",
  "rt.page.edit": "편집 ↗",
  "rt.page.walk": "걷기 {time}",
  "rt.page.spotCount": "스팟 {count}개",
  "rt.page.spotCount.one": "스팟 {count}개",
  "rt.page.docTitle": "{title} · Mapus",
  "rt.page.docTitleEmpty": "Mapus",
  "rt.explainer.title": "루트 퀘스트란?",
  "rt.explainer.what":
    "루트 퀘스트는 지도 위에 선으로 그린 경로를, 실제 거리에서 걷거나 달리거나 자전거로 따라가는 퀘스트예요. GPS로 기록한 이동 경로가 그 선과 겹치면서 경로를 따라 채워 나가요.",
  "rt.explainer.howAnywhereNoLimit":
    "출발 지점이 정해져 있지 않다면 경로 위 아무 곳에서 시작해 선을 따라가면 돼요. 얼마나 잘 맞췄는지 매치율로 확인할 수 있고, 제한 시간 없이 자신의 페이스로 즐기면 됩니다.",
  "rt.explainer.howAnywhereLimit":
    "출발 지점이 정해져 있지 않다면 경로 위 아무 곳에서 시작해 선을 따라가면 돼요. 얼마나 잘 맞췄는지 매치율로 확인할 수 있고, 이 퀘스트는 {count}분 제한이 있어요.",
  "rt.explainer.howFixedNoLimit":
    "표시된 출발 지점에서 시작해 선을 따라 도착 지점까지 가면 돼요. 얼마나 잘 맞췄는지 매치율로 확인할 수 있고, 제한 시간 없이 자신의 페이스로 즐기면 됩니다.",
  "rt.explainer.howFixedLimit":
    "표시된 출발 지점에서 시작해 선을 따라 도착 지점까지 가면 돼요. 얼마나 잘 맞췄는지 매치율로 확인할 수 있고, 이 퀘스트는 {count}분 제한이 있어요.",
  "rt.explainer.tips":
    "안전과 교통법규를 지키고, 주민과 사유지를 존중해 주세요. 필요할 때는 언제든 멈췄다가 이어서 진행해도 됩니다.",
  "rt.summary.placeRoute": "{place} 일대를 도는 {distance} 루트 퀘스트예요.",
  "rt.summary.titleRoute": "{title} — {distance} 루트 퀘스트예요.",
  "rt.summary.walk": "걷기로 약 {time} 걸려요.",
  "rt.summary.endpoints": "{start}에서 {finish}까지 이어져요.",
  "rt.summary.byAuthor": "만든 사람은 {name}예요.",
  "rt.summary.published": "{date}에 공개됐어요.",
  "rt.map.compassNorth": "나침반: 북쪽을 위로",
  "rt.map.compassBack": "나침반: 이전 방향으로 돌아가기",
  "rt.map.compassRoute": "나침반: 경로 방향으로 돌리기",
  "rt.map.reset": "처음 화면으로",
  "rt.map.resetSpots": "스팟 전체 보기",
  "rt.map.zoom": "확대/축소",
  "rt.map.zoomIn": "확대",
  "rt.map.zoomOut": "축소",
  "rt.map.myLocation": "현재 위치",
  "rt.map.gestureWindows": "Ctrl + 스크롤로 지도를 확대/축소하세요",
  "rt.map.gestureMac": "⌘ + 스크롤로 지도를 확대/축소하세요",
  "rt.map.gestureMobile": "두 손가락으로 지도를 움직이세요",
  "rt.map.satellite": "위성",
  "rt.map.map": "지도",
  "rt.map.openStreetView": "거리뷰로 보기",
  "rt.map.openStreetViewInApp": "앱에서 거리뷰",
  "rt.map.closeStreetView": "거리뷰 닫기",
  "rt.map.streetViewPanel": "거리뷰",
  "rt.map.streetViewProviderNaver": "네이버 거리뷰",
  "rt.map.streetViewProviderKakao": "카카오 로드뷰",
  "rt.map.streetViewUnavailable": "이 위치에는 거리뷰가 없습니다",
  "rt.map.streetViewCoverage": "촬영 구간",
  "rt.map.streetViewNoCoverageAtCenter": "지도 중심에 거리뷰 없음",
  "rt.page.by": "만든 사람 {name}",
  "rt.strip.fixed": "출발·도착 고정",
  "rt.strip.anywhere": "경로 어디서나 출발",
  "rt.strip.limit": "제한 {count}분",
  "rt.strip.noLimit": "제한 시간 없음",
  "rt.step": "{total}단계 중 {n}",
  "rt.back": "뒤로",
  "rt.next": "다음",
  "rt.done": "완료",
  "rt.close": "닫기",
  "rt.set.kicker1": "경로 설정 · 출발과 도착",
  "rt.set.q1": "어디서 출발하고 어디서 끝나나요?",
  "rt.set.anywhere": "경로 어디서나 출발",
  "rt.set.fixed": "출발·도착 고정",
  "rt.set.fixedNote": "출발·도착을 고정하면 선 위에 놓는 단계가 하나 더 생겨요.",
  "rt.set.anywhereNote": "원하는 곳에서 경로에 합류할 수 있어요.",
  "rt.set.kicker2": "경로 설정 · 출발과 도착 놓기",
  "rt.set.q2": "지도의 선을 눌러 놓아 주세요",
  "rt.set.sub2": "핀은 경로에 붙고 바로 페이지에 보여요.",
  "rt.set.placed": "놓음",
  "rt.set.placingStart": "이제 출발할 곳의 선을 누르세요…",
  "rt.set.placingFinish": "이제 끝나는 곳의 선을 누르세요…",
  "rt.set.placing": "놓는 중",
  "rt.set.tapHint": "선을 눌러 {pin} 놓기",
  "rt.set.miss": "선에 더 가까이 눌러 주세요.",
  "rt.set.kicker3": "경로 설정 · 제한 시간",
  "rt.set.q3": "제한 시간이 있나요?",
  "rt.set.noLimit": "제한 없음",
  "rt.set.limit": "제한 시간 정하기",
  "rt.set.within": "완주 시간",
  "rt.set.min": "분",
  "rt.ttl.kicker1": "제목과 커버 · 제목",
  "rt.ttl.q1": "퀘스트 이름이 뭔가요?",
  "rt.ttl.kicker2": "제목과 커버 · 커버",
  "rt.ttl.q2": "커버 사진을 넣을까요?",
  "rt.ttl.coverSub": "사진이 없으면 경로 지도가 커버가 돼요.",
  "rt.ttl.upload": "사진 올리기",
  "rt.ttl.skip": "건너뛰기",
  "rt.description.kicker": "설명",
  "rt.description.q": "어떤 퀘스트인가요?",
  "rt.description.placeholder": "제목 아래에 보일 짧은 소개",
  "rt.story.kicker": "소개 이야기",
  "rt.story.q": "여기엔 어떤 이야기가 있나요?",
  "rt.manners.kicker": "매너",
  "rt.manners.q": "나누고 싶은 길 위의 매너가 있나요?",
  "rt.routeSaved": "에디터에서 경로를 업데이트했어요.",
  "rt.signIn": "로그인하고 퀘스트를 만드세요.",
  "qroute.title": "경로 편집",
  "qroute.docTitle": "경로 편집 · {title} · Mapus",
  "qroute.docTitleUntitled": "경로 편집 · Mapus",
  "qroute.banner": "“{title}” 퀘스트. 저장하면 경로가 퀘스트 페이지로 가요.",
  "qroute.bannerUntitled": "저장하면 경로가 퀘스트 페이지로 가요.",
  "qroute.done": "완료",
  "qroute.keymapSave": "경로 저장",
  "qroute.keymapDone": "완료",
  "qroute.sent": "경로를 퀘스트로 보냈어요. 이 탭은 닫아도 돼요.",
  "qroute.failed": "경로를 퀘스트로 보내지 못했어요.",
  "qroute.defaultName": "퀘스트 경로",
  "qroute.locked": "공개된 퀘스트라 경로를 바꿀 수 없어요.",
  "qroute.workPrompt": "지도에서 드래그해서 사각형으로 경로의 캔버스를 지정하면 돼.",
  "qroute.disconnected": "끊긴 구간이 있어 경로를 저장할 수 없습니다.",
  "qroute.statsDisconnected": "끊김 · {count}곳",
  "qroute.selectSmallerParts": "작은 부분 선택",
  "qroute.cacheCleared": "지도 캐시를 지웠어요.",
  "qroute.signIn": "로그인하고 이 퀘스트의 경로를 편집하세요.",
  "qroute.signInSave": "Google로 로그인하고 경로를 저장하세요.",
  "qroute.notOwner": "퀘스트를 만든 사람만 경로를 편집할 수 있어요.",
  "qroute.openQuest": "퀘스트 페이지 열기",
  "qroute.loading": "경로를 여는 중…",
  "toast.publishMoved": "그림 공개는 닫혔어요. 대신 퀘스트를 만드세요: 새 퀘스트 → GPS 아트 퀘스트.",
  "lang.label": "언어",
  "lang.saveFirst": "먼저 저장하거나 편집을 나간 뒤 언어를 바꾸세요.",
  "lang.saveFailed": "저장하지 못해 언어를 바꾸지 않았어요.",
  "api.failed": "요청 실패 ({status})",
  "cover.add": "커버 사진 추가",
  "cover.addSub": "클릭하거나 사진을 끌어다 놓으세요",
  "cover.replace": "바꾸기",
  "cover.remove": "삭제",
  "cover.removeConfirm": "커버를 삭제할까요?",
  "cover.removed": "커버를 삭제했어요.",
  "cover.saved": "커버를 저장했어요.",
  "cover.uploading": "올리는 중…",
  "cover.notice": "직접 찍었거나 사용 권한이 있는 사진만 올려주세요. 다른 사람 얼굴이 크게 나온 사진은 동의를 받아주세요.",
  "cover.err.type": "이미지 파일을 골라주세요.",
  "cover.err.size": "15MB가 넘는 사진이에요.",
  "cover.err.read": "이 사진을 열 수 없어요. JPEG나 PNG로 해보세요.",
  "cover.mapAlt": "경로 지도",
  "cover.crop.title": "커버 위치 맞추기",
  "cover.crop.hint": "끌어서 옮기고 확대해 맞추세요.",
  "cover.crop.zoom": "확대",
  "cover.crop.cancel": "취소",
  "cover.crop.use": "이 사진 쓰기",
  "cover.adminRemove": "커버 삭제",
  "report.button": "신고",
  "report.title": "퀘스트 신고",
  "report.reason.spam": "스팸",
  "report.reason.unsafe": "위험한 내용",
  "report.reason.copyright": "저작권 침해",
  "report.reason.other": "기타",
  "report.cancel": "취소",
  "report.sent": "신고가 접수됐어요.",
  "cover.titlePlaceholder": "퀘스트 제목",
  "done.title": "완료한 사람",
  "done.empty": "아직 완료한 사람이 없어요. 첫 번째가 돼보세요",
  "done.more": "더보기",
  "done.anon": "참가자",
  "done.hint": "퀘스트를 완료하면 여기에 한 줄을 남길 수 있어요",
  "done.write": "한 줄 남기기",
  "done.post": "남기기",
  "done.save": "저장",
  "done.cancel": "취소",
  "done.edit": "수정",
  "done.delete": "삭제",
  "done.report": "신고",
  "done.remove": "삭제",
  "done.removed": "한 줄을 삭제했어요.",
  "done.err.empty": "먼저 한 줄을 써 주세요.",
  "done.err.long": "짧은 한 줄로 써 주세요 ({max}자).",
  "done.err.link": "한 줄에는 링크를 넣을 수 없어요.",
  "ads.label": "광고",
  "ads.previewLabel": "광고 자리 · 미리보기",
  "ads.previewProposed": "제안",
  "privacy.title": "개인정보 처리방침",
  "privacy.link": "개인정보 처리방침",
  "legal.aria": "법적 고지 및 문의",
  "legal.about": "소개",
  "legal.privacy": "개인정보",
  "legal.terms": "이용약관",
  "legal.contact": "문의",
  "privacy.adsense.title": "광고",
  "privacy.adsense.body":
    "광고가 켜져 있을 때 Google AdSense가 퀘스트 페이지와 홈 상세 패널에 광고를 표시할 수 있습니다. Google 및 파트너는 맞춤 광고 등을 위해 쿠키나 유사 기술을 사용할 수 있습니다. 자세한 내용은 Google의 광고 정책(https://policies.google.com/technologies/ads)을 참고하세요. 유럽경제지역(EEA)과 영국에서는 AdSense에서 Google 인증 CMP(Funding Choices)를 설정해야 맞춤 광고를 제공할 수 있습니다.",
} satisfies Catalog;
